<template>
  <div>

    <modal 
      :show.sync="showAddCriterionModal"
      id="addCriterionModal"
      :centered="false"
      :show-close="true"
    >
      <template slot="header">Add Criterion to Dashboard</template>  

      <div class="row">
        <div class="col-12">
          <div class="form-group mb-3">
            <select class="form-control" v-model="addCriterionPillar" @change="selectedEnvironmentalCriterion=null;selectedSocialCriterion=null;selectedGovernanceCriterion=null;selectedFinancialCriterion=null;selectedGriCriterion=null;">
              <option :value="null">Select pillar</option>
              <option v-for="(pillr, index) in pillars" :key="index" :value="pillr">{{ pillr }}</option>
            </select>
          </div>
        </div>
      </div>

      <div class="row" v-show="addCriterionPillar==='environmental'">
        <div class="col-12">
          <div class="form-group">
            <v-select  
              id="criteria_environmental_select"
              :class="{empty: showEnvironmentalSelectorPlaceholder}" 
              v-model="selectedEnvironmentalCriterion" 
              :options="criteriaFlat.environmental"
              :selectable="(option) => option.selectable"
              @open="isEnvironmentalSelectorFocused=true" 
              @close="isEnvironmentalSelectorFocused=false"
            ></v-select>
          </div>
          <div class="form-group">
            <select class="form-control" v-model="selectedVisualType">
              <option :value="'barchart'">Barchart</option>
              <option :value="'list'">List</option>
            </select>
          </div>
          <div class="form-group">
            <label class="ml-1">
              <input type="checkbox" v-model="industryScope"/>
              Industry scope
            </label>
          </div>
          <div class="form-group">
            <label class="ml-1">
              <input type="checkbox" v-model="bestPerforming"/>
              Best performing
            </label>
          </div>
          <div class="form-group">
            <button class="btn btn-primary" :disabled="!selectedEnvironmentalCriterion" @click="addSelectedCriterion(selectedEnvironmentalCriterion.code.split('criterion-').join(''), selectedEnvironmentalCriterion.label, selectedVisualType, industryScope, bestPerforming);selectedEnvironmentalCriterion=null;">Add</button>
          </div>
        </div>
      </div>

      <div class="row" v-show="addCriterionPillar==='social'">
        <div class="col-12">
          <div class="form-group">
            <v-select  
              id="criteria_social_select"
              :class="{empty: showSocialSelectorPlaceholder}" 
              v-model="selectedSocialCriterion" 
              :options="criteriaFlat.social"
              :selectable="(option) => option.selectable"
              @open="isSocialSelectorFocused=true" 
              @close="isSocialSelectorFocused=false"
            ></v-select>
          </div>
          <div class="form-group">
            <select class="form-control" v-model="selectedVisualType">
              <option :value="'barchart'">Barchart</option>
              <option :value="'list'">List</option>
            </select>
          </div>
          <div class="form-group">
            <label class="ml-1">
              <input type="checkbox" v-model="industryScope"/>
              Industry scope
            </label>
          </div>
          <div class="form-group">
            <label class="ml-1">
              <input type="checkbox" v-model="bestPerforming"/>
              Best performing
            </label>
          </div>
          <div class="form-group">
            <button class="btn btn-primary" :disabled="!selectedSocialCriterion" @click="addSelectedCriterion(selectedSocialCriterion.code.split('criterion-').join(''), selectedSocialCriterion.label, selectedVisualType, industryScope, bestPerforming);selectedSocialCriterion=null;">Add</button>
          </div>
        </div>
      </div>

      <div class="row" v-show="addCriterionPillar==='governance'">
        <div class="col-12">
          <div class="form-group">
            <v-select  
              id="criteria_governance_select"
              :class="{empty: showGovernanceSelectorPlaceholder}" 
              v-model="selectedGovernanceCriterion" 
              :options="criteriaFlat.governance"
              :selectable="(option) => option.selectable"
              @open="isGovernanceSelectorFocused=true" 
              @close="isGovernanceSelectorFocused=false"
            ></v-select>
          </div>
          <div class="form-group">
            <select class="form-control" v-model="selectedVisualType">
              <option :value="'barchart'">Barchart</option>
              <option :value="'list'">List</option>
            </select>
          </div>
          <div class="form-group">
            <label class="ml-1">
              <input type="checkbox" v-model="industryScope"/>
              Industry scope
            </label>
          </div>
          <div class="form-group">
            <label class="ml-1">
              <input type="checkbox" v-model="bestPerforming"/>
              Best performing
            </label>
          </div>
          <div class="form-group">
            <button class="btn btn-primary" :disabled="!selectedGovernanceCriterion" @click="addSelectedCriterion(selectedGovernanceCriterion.code.split('criterion-').join(''), selectedGovernanceCriterion.label, selectedVisualType, industryScope, bestPerforming);selectedGovernanceCriterion=null;">Add</button>
          </div>
        </div>
      </div>

      <div class="row" v-show="addCriterionPillar==='financial'">
        <div class="col-12">
          <div class="form-group">
            <v-select  
              id="criteria_financial_select"
              :class="{empty: showFinancialSelectorPlaceholder}" 
              v-model="selectedFinancialCriterion" 
              :options="criteriaFlat.financial"
              :selectable="(option) => option.selectable"
              @open="isFinancialSelectorFocused=true" 
              @close="isFinancialSelectorFocused=false"
            ></v-select>
          </div>
          <div class="form-group">
            <select class="form-control" v-model="selectedVisualType">
              <option :value="'barchart'">Barchart</option>
              <option :value="'list'">List</option>
            </select>
          </div>
          <div class="form-group">
            <label class="ml-1">
              <input type="checkbox" v-model="industryScope"/>
              Industry scope
            </label>
          </div>
          <div class="form-group">
            <label class="ml-1">
              <input type="checkbox" v-model="bestPerforming"/>
              Best performing
            </label>
          </div>
          <div class="form-group">
            <button class="btn btn-primary" :disabled="!selectedFinancialCriterion" @click="addSelectedCriterion(selectedFinancialCriterion.code.split('criterion-').join(''), selectedFinancialCriterion.label, selectedVisualType, industryScope, bestPerforming);selectedFinancialCriterion=null;">Add</button>
          </div>
        </div>
      </div>

      <div class="row" v-show="addCriterionPillar==='general'">
        <div class="col-12">
          <div class="form-group">
            <v-select  
              id="criteria_gri_select"
              :class="{empty: showGriSelectorPlaceholder}" 
              v-model="selectedGriCriterion" 
              :options="criteriaFlat.general"
              :selectable="(option) => option.selectable"
              @open="isGriSelectorFocused=true" 
              @close="isGriSelectorFocused=false"
            ></v-select>
          </div>
          <div class="form-group">
            <select class="form-control" v-model="selectedVisualType">
              <option :value="'barchart'">Barchart</option>
              <option :value="'list'">List</option>
            </select>
          </div>
          <div class="form-group">
            <label class="ml-1">
              <input type="checkbox" v-model="industryScope"/>
              Industry scope
            </label>
          </div>
          <div class="form-group">
            <label class="ml-1">
              <input type="checkbox" v-model="bestPerforming"/>
              Best performing
            </label>
          </div>
          <div class="form-group">
            <button class="btn btn-primary" :disabled="!selectedGriCriterion" @click="addSelectedCriterion(selectedGriCriterion.code.split('criterion-').join(''), selectedGriCriterion.label, selectedVisualType, industryScope, bestPerforming);selectedGriCriterion=null;">Add</button>
          </div>
        </div>
      </div>

      <hr>

      <div class="text-center">
        <button class="btn btn-neutral" @click="showAddCriterionModal=false;">Close</button>
      </div>

    </modal>

    <div class="row">
      <div class="col-12">
        <div class="pull-left">
          <button class="btn btn-prmary" @click="showAddCriterionModal=true">Add Criteria</button>
        </div>
        <div class="form-inline pull-right mb-3">
          <div class="form-group">
            <v-select id="country_filter" 
                      :class="{empty: showCountryFilterPlaceholder}" 
                      v-model="countryIds" 
                      @input="fetchData" 
                      :options="countriesFlat" multiple 
                      @open="isCountryFilterFocused=true" 
                      @close="isCountryFilterFocused=false"></v-select>
          </div>
          <div class="m-1"></div>
          <div class="form-group">
            <select v-model="year" class="form-control" @change="fetchData">
              <option v-for="y in years" :key="y" :value="y">{{ y }}</option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-md-6 col-xl-4" v-for="(item,index) in industryEvaluations" :key="'industry-evaluation-' + index">
        <card class="card">
          <div style="position:absolute;top:5px;right:5px;cursor:pointer;" @click="removeSelectedCriterion(item.criterionId, true);"><i class="tim-icons icon-simple-remove"></i></div>
          <template slot="header">
            <h4 class="card-title mb-0">
              {{ item.criterionTitle }}
            </h4>
            <div class="text-muted-bg">
              <span v-if="item.bestPerforming"><span class="icomoon-smile2"></span> Best performing industries</span>
              <span v-else><span class="icomoon-sad2"></span> Worst performing industries</span>
            </div>
          </template>
          <div v-if="item.type === 'barchart'">
            <div v-if="item.data">
              <horizontal-bar-chart
                :height="300"
                :chart-data="item.data"
                :extra-options="chartOptions">
              </horizontal-bar-chart>
            </div>
            <div v-else>
              No data for {{ year }}
            </div>
          </div>
          <div v-if="item.type === 'list'" class="table-responsive">
            <div v-if="item.data">
              <base-table
                :data="item.data"
                :columns="['#', 'Industry', 'Value']"
                thead-classes="text-primary">
              </base-table>
            </div>
            <div v-else>
              No data for {{ year }}
            </div>
          </div>
        </card>
      </div>
      <div class="col-12 col-md-6 col-xl-4" v-for="(item,index) in evaluations" :key="'company-evaluation-' + index">
        <card class="card">
          <div style="position:absolute;top:5px;right:5px;cursor:pointer;" @click="removeSelectedCriterion(item.criterionId, false);"><i class="tim-icons icon-simple-remove"></i></div>
          <template slot="header">
            <h4 class="card-title mb-0">
              {{ item.criterionTitle }}
            </h4>
            <div class="text-muted-bg">
              <span v-if="item.bestPerforming"><span class="icomoon-smile2"></span> Best performing companies</span>
              <span v-else><span class="icomoon-sad2"></span> Worst performing companies</span>
            </div>
          </template>
          <div v-if="item.type === 'barchart'">
            <div v-if="item.data">
              <horizontal-bar-chart
                :height="300"
                :chart-data="item.data"
                :extra-options="chartOptions">
              </horizontal-bar-chart>
            </div>
            <div v-else>
              No data for {{ year }}
            </div>
          </div>
          <div v-if="item.type === 'list'" class="table-responsive">
            <div v-if="item.data">
              <base-table
                :data="item.data"
                :columns="['#', 'Company', 'Value']"
                thead-classes="text-primary">
              </base-table>
            </div>
            <div v-else>
              No data for {{ year }}
            </div>
          </div>
        </card>
      </div>
    </div>

    <!-- <div class="row">
      <div class="col-12">
        <card type="chart">
          <template slot="header">
            <div class="row">
              <div class="col-sm-6 text-left">
                <h5 class="card-category">{{$t('dashboard.totalShipments')}}</h5>
                <h2 class="card-title">{{$t('dashboard.performance')}}</h2>
              </div>
              <div class="col-sm-6">
                <div class="btn-group btn-group-toggle float-right"
                     data-toggle="buttons">
                  <label v-for="(option, index) in bigLineChartCategories"
                         :key="option"
                         class="btn btn-sm btn-primary btn-simple"
                         :class="{active: bigLineChart.activeIndex === index}"
                         :id="index">
                    <input type="radio"
                           @click="initBigChart(index)"
                           name="options" autocomplete="off"
                           :checked="bigLineChart.activeIndex === index">
                    {{option}}
                  </label>
                </div>
              </div>
            </div>
          </template>
          <div class="chart-area">
            <line-chart style="height: 100%"
                        ref="bigChart"
                        chart-id="big-line-chart"
                        :chart-data="bigLineChart.chartData"
                        :gradient-colors="bigLineChart.gradientColors"
                        :gradient-stops="bigLineChart.gradientStops"
                        :extra-options="bigLineChart.extraOptions">
            </line-chart>
          </div>
        </card>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-4">
        <card type="chart">
          <template slot="header">
            <h5 class="card-category">{{$t('dashboard.totalShipments')}}</h5>
            <h3 class="card-title"><i class="tim-icons icon-bell-55 text-primary "></i> 763,215</h3>
          </template>
          <div class="chart-area">
            <line-chart style="height: 100%"
                        chart-id="purple-line-chart"
                        :chart-data="purpleLineChart.chartData"
                        :gradient-colors="purpleLineChart.gradientColors"
                        :gradient-stops="purpleLineChart.gradientStops"
                        :extra-options="purpleLineChart.extraOptions">
            </line-chart>
          </div>
        </card>
      </div>
      <div class="col-lg-4">
        <card type="chart">
          <template slot="header">
            <h5 class="card-category">{{$t('dashboard.dailySales')}}</h5>
            <h3 class="card-title"><i class="tim-icons icon-delivery-fast text-info "></i> 3,500€</h3>
          </template>
          <div class="chart-area">
            <bar-chart style="height: 100%"
                       chart-id="blue-bar-chart"
                       :chart-data="blueBarChart.chartData"
                       :gradient-stops="blueBarChart.gradientStops"
                       :extra-options="blueBarChart.extraOptions">
            </bar-chart>
          </div>
        </card>
      </div>
      <div class="col-lg-4">
        <card type="chart">
          <template slot="header">
            <h5 class="card-category">{{$t('dashboard.completedTasks')}}</h5>
            <h3 class="card-title"><i class="tim-icons icon-send text-success "></i> 12,100K</h3>
          </template>
          <div class="chart-area">
            <line-chart style="height: 100%"
                        chart-id="green-line-chart"
                        :chart-data="greenLineChart.chartData"
                        :gradient-stops="greenLineChart.gradientStops"
                        :extra-options="greenLineChart.extraOptions">
            </line-chart>
          </div>
        </card>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6 col-md-12">
        <card type="tasks">
          <template slot="header">
            <h6 class="title d-inline">{{$t('dashboard.tasks', {count: 5})}}</h6>
            <p class="card-category d-inline">{{$t('dashboard.today')}}</p>
            <base-dropdown menu-on-right=""
                           tag="div"
                           title-classes="btn btn-link btn-icon"
                           aria-label="Settings menu">
              <i slot="title" class="tim-icons icon-settings-gear-63"></i>
              <a class="dropdown-item" href="#pablo">{{$t('dashboard.dropdown.action')}}</a>
              <a class="dropdown-item" href="#pablo">{{$t('dashboard.dropdown.anotherAction')}}</a>
              <a class="dropdown-item" href="#pablo">{{$t('dashboard.dropdown.somethingElse')}}</a>
            </base-dropdown>
          </template>
          <div class="table-full-width table-responsive">
            <task-list></task-list>
          </div>
        </card>
      </div>
      <div class="col-lg-6 col-md-12">
        <card class="card">
          <h4 slot="header" class="card-title">{{$t('dashboard.simpleTable')}}</h4>
          <div class="table-responsive">
            <user-table></user-table>
          </div>
        </card>
      </div>
    </div> -->

  </div>
</template>
<script>
  import LineChart from '@/components/Charts/LineChart';
  import BarChart from '@/components/Charts/BarChart';
  import HorizontalBarChart from "@/components/Charts/HorizontalBarChart";
  import * as chartConfigs from '@/components/Charts/config';
  import TaskList from './Dashboard/TaskList';
  import UserTable from './Dashboard/UserTable';
  import BaseTable from '@/components/BaseTable';
  import config from '@/config';
  import Api from "../api";
  import Card from '../components/Cards/Card.vue';
  import vSelect from 'vue-select';
  import 'vue-select/dist/vue-select.css';
  import Modal from '@/components/Modal';

  export default {
    components: {
      LineChart,
      BarChart,
      HorizontalBarChart,
      TaskList,
      UserTable,
      BaseTable,
      Card,
      vSelect,
      Modal
    },
    data() {
      return {
        loading: false,
        year: (localStorage.getItem('dashboard_year')) ? localStorage.getItem('dashboard_year') : (new Date).getFullYear() - 1,
        years: [],
        selectedIndustryCriteria: [],
        selectedCriteria: [],
        industryEvaluations: [],
        evaluations: [],
        selectedEnvironmentalCriterion: null,
        selectedSocialCriterion: null,
        selectedGovernanceCriterion: null,
        selectedFinancialCriterion: null,
        selectedGriCriterion: null,
        isEnvironmentalSelectorFocused: false,
        isSocialSelectorFocused: false,
        isGovernanceSelectorFocused: false,
        isFinancialSelectorFocused: false,
        isGriSelectorFocused: false,
        selectedVisualType: 'barchart',
        showAddCriterionModal: false,
        addCriterionPillar: null,
        industryScope: false,
        bestPerforming: false,
        countryIds: (localStorage.getItem('dashboard_countries')) ? JSON.parse(localStorage.getItem('dashboard_countries')) : [],
        countriesFlat: [],
        countriesIndex: {},
        isCountryFilterFocused: false,
        criteriaFlat: {
          environmental: [],
          social: [],
          governance: [],
          financial: [],
          general: []
        },
        topicsTree: {
          environmental: {
            title: 'Environmental Criteria',
            id: null,
            childrenDtos: []
          },
          social: {
            title: 'Social Criteria',
            id: null,
            childrenDtos: []
          },
          governance: {
            title: 'Governance Criteria',
            id: null,
            childrenDtos: []
          },
          financial: {
            title: 'Financial Criteria',
            id: null,
            childrenDtos: []
          },
          general: {
            title: 'General Criteria',
            id: null,
            childrenDtos: []
          },
        },
        chartOptions: {
          legend: false,
          scales: {
            yAxes: [{ticks: {mirror: true, z: 1, padding: -5, fontColor: '#222222'}}],
            xAxes: [{
              ticks: {beginAtZero: true},
              afterTickToLabelConversion: function(q) {
                for (var tick in q.ticks) {
                  if (q.ticks[tick] > 1000000000000 || q.ticks[tick] < -1000000000000) {
                    q.ticks[tick] = (q.ticks[tick]/1000000000000).toFixed(2) + 'T';
                    continue;
                  }

                  if (q.ticks[tick] > 1000000000 || q.ticks[tick] < -1000000000) {
                    q.ticks[tick] = (q.ticks[tick]/1000000000).toFixed(2) + 'B';
                    continue;
                  }

                  if (q.ticks[tick] > 1000000 || q.ticks[tick] < -1000000) {
                    q.ticks[tick] = (q.ticks[tick]/1000000).toFixed(2) + 'M';
                    continue;
                  }

                  if (q.ticks[tick] > 1000 || q.ticks[tick] < -1000) {
                    q.ticks[tick] = (q.ticks[tick]/1000).toFixed(2) + 'K';
                    continue;
                  }

                  q.ticks[tick] = parseFloat(q.ticks[tick]).toFixed(4).replace(/0+$/, "").replace(/\.$/, "");
                }
              }
            }]
          }, 
          tooltips: {
            callbacks: {
              label: (tooltipItem, data) => {
                return this.formatNumber(tooltipItem.value);
              }
            }
          }, 
          responsive: true,
          maintainAspectRatio: true,
        },
        bigLineChart: {
          allData: [
            [100, 70, 90, 70, 85, 60, 75, 60, 90, 80, 110, 100],
            [80, 120, 105, 110, 95, 105, 90, 100, 80, 95, 70, 120],
            [60, 80, 65, 130, 80, 105, 90, 130, 70, 115, 60, 130]
          ],
          activeIndex: 0,
          chartData: {
            datasets: [{ }],
            labels: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
          },
          extraOptions: chartConfigs.purpleChartOptions,
          gradientColors: config.colors.primaryGradient,
          gradientStops: [1, 0.4, 0],
          categories: []
        },
        purpleLineChart: {
          extraOptions: chartConfigs.purpleChartOptions,
          chartData: {
            labels: ['JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
            datasets: [{
              label: "Data",
              fill: true,
              borderColor: config.colors.primary,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.primary,
              pointBorderColor: 'rgba(255,255,255,0)',
              pointHoverBackgroundColor: config.colors.primary,
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [80, 100, 70, 80, 120, 80],
            }]
          },
          gradientColors: config.colors.primaryGradient,
          gradientStops: [1, 0.2, 0],
        },
        greenLineChart: {
          extraOptions: chartConfigs.greenChartOptions,
          chartData: {
            labels: ['JUL', 'AUG', 'SEP', 'OCT', 'NOV'],
            datasets: [{
              label: "My First dataset",
              fill: true,
              borderColor: config.colors.danger,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.danger,
              pointBorderColor: 'rgba(255,255,255,0)',
              pointHoverBackgroundColor: config.colors.danger,
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [90, 27, 60, 12, 80],
            }]
          },
          gradientColors: ['rgba(66,134,121,0.15)', 'rgba(66,134,121,0.0)', 'rgba(66,134,121,0)'],
          gradientStops: [1, 0.4, 0],
        },
        blueBarChart: {
          extraOptions: chartConfigs.barChartOptions,
          chartData: {
            labels: ['USA', 'GER', 'AUS', 'UK', 'RO', 'BR'],
            datasets: [{
              label: "Countries",
              fill: true,
              borderColor: config.colors.info,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: [53, 20, 10, 80, 100, 45],
            }]
          },
          gradientColors: config.colors.primaryGradient,
          gradientStops: [1, 0.4, 0],
        },
        frameworks: ['nza'],
        pillars: ['environmental']
      }
    },
    computed: {
      bigLineChartCategories() {
        return this.$t('dashboard.chartCategories');
      },
      showEnvironmentalSelectorPlaceholder() {
        return !this.selectedEnvironmentalCriterion && !this.isEnvironmentalSelectorFocused;
      },
      showSocialSelectorPlaceholder() {
        return !this.selectedSocialCriterion && !this.isSocialSelectorFocused;
      },
      showGovernanceSelectorPlaceholder() {
        return !this.selectedGovernanceCriterion && !this.isGovernanceSelectorFocused;
      },
      showFinancialSelectorPlaceholder() {
        return !this.selectedFinancialCriterion && !this.isFinancialSelectorFocused;
      },
      showGriSelectorPlaceholder() {
        return !this.selectedGriCriterion && !this.isGriSelectorFocused;
      },
      showCountryFilterPlaceholder() {
        return this.countryIds.length === 0 && !this.isCountryFilterFocused;
      }
    },
    methods: {
      initBigChart(index) {
        let chartData = {
          datasets: [{
            fill: true,
            borderColor: config.colors.primary,
            borderWidth: 2,
            borderDash: [],
            borderDashOffset: 0.0,
            pointBackgroundColor: config.colors.primary,
            pointBorderColor: 'rgba(255,255,255,0)',
            pointHoverBackgroundColor: config.colors.primary,
            pointBorderWidth: 20,
            pointHoverRadius: 4,
            pointHoverBorderWidth: 15,
            pointRadius: 4,
            data: this.bigLineChart.allData[index]
          }],
          labels: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
        }
        this.$refs.bigChart.updateGradients(chartData);
        this.bigLineChart.chartData = chartData;
        this.bigLineChart.activeIndex = index;
      },
      fetchData() {
        localStorage.setItem('dashboard_year', this.year);
        localStorage.setItem('dashboard_countries', JSON.stringify(this.countryIds));
        this.industryEvaluations = [];
        this.evaluations = [];
        this.fetchAllCriterionEvaluations();
      },
      fetchAllCriterionEvaluations() {
        let tmp = {};
        for(let i=0; i<this.industryEvaluations.length; i++) {
          tmp[this.industryEvaluations[i].criterionId] = true;
        }
        for (let j=0; j<this.selectedIndustryCriteria.length; j++) {
          if (!tmp[this.selectedIndustryCriteria[j].criterionId]) {
            this.fetchCriterionEvaluations(this.selectedIndustryCriteria[j].criterionId, 'SUM', this.selectedIndustryCriteria[j].type, this.selectedIndustryCriteria[j].criterionTitle, true, this.selectedIndustryCriteria[j].bestPerforming);
          }
        }

        tmp = {};
        for(let i=0; i<this.evaluations.length; i++) {
          tmp[this.evaluations[i].criterionId] = true;
        }
        for (let j=0; j<this.selectedCriteria.length; j++) {
          if (!tmp[this.selectedCriteria[j].criterionId]) {
            this.fetchCriterionEvaluations(this.selectedCriteria[j].criterionId, 'SUM', this.selectedCriteria[j].type, this.selectedCriteria[j].criterionTitle, false, this.selectedCriteria[j].bestPerforming);
          }
        }

        localStorage.setItem('dashboard_industry_criteria', JSON.stringify(this.selectedIndustryCriteria));
        localStorage.setItem('dashboard_company_criteria', JSON.stringify(this.selectedCriteria));
      },
      fetchCriterionEvaluations(criterionId, aggregator, type, criterionTitle, isForIndustries, bestPerforming) {
        if (!criterionId) {
          return false;
        }
        let self = this;
        let url = '';
        let _countryIds = self.countryIds.map((x) => {
          return x.code;
        });
        if (isForIndustries) {
          url = '/prism/criterion/' + criterionId + '/industry_evaluations?aggregator=' + aggregator + '&year=' + self.year + '&country=' + _countryIds.join('_');
        } else {
          url = '/prism/criterion/' + criterionId + '/evaluations?year=' + self.year + '&country=' + _countryIds.join('_');
        }
        self.loading = true;
        Api.send('GET', url, {})
        .then((response) => {
          if (response.length) {
            let tmp1 = [];
            let tmp2 = [];
            if (isForIndustries) {
              for (let i in response) {
                if (response[i].industryParentId) {
                  tmp2.push(response[i]);
                } else {
                  tmp1.push(response[i]);
                }
              }
            } else {
              tmp1 = response;
            }

            let tmp11 = [];
            let tmp22 = [];
            const tmpLength = tmp1.length;
            if (tmpLength > 5) {
              if (bestPerforming) {
                for (let i=0; i<5; i++) {
                  tmp11.push(tmp1[i]);
                }
              } else {
                for (let i=tmpLength-1; i>tmpLength-6; i--) {
                  tmp11.push(tmp1[i]);
                }
              }
            } else {
              if (bestPerforming) {
                for (let i=0; i<tmpLength; i++) {
                  tmp11.push(tmp1[i]);
                }
              } else {
                for (let i=tmpLength-1; i>-1; i--) {
                  tmp11.push(tmp1[i]);
                }
              }
            }

            if (type === 'barchart') {
              if (isForIndustries) {
                self.industryEvaluations.push({
                  criterionTitle: criterionTitle,
                  criterionId: criterionId,
                  type: type,
                  bestPerforming: bestPerforming,
                  data: {
                    datasets: [
                      {
                        data: tmp11.map(v => v.evaluationAnalystAnswerNumeric),
                        backgroundColor: (bestPerforming) ? "rgb(106 225 171 / 0.53)" : "rgb(238 6 6 / 0.53)",
                        hoverBackgroundColor: (bestPerforming) ? "rgb(106 225 171 / 0.63)" : "rgb(238 6 6 / 0.63)",
                      }
                    ],
                    labels: tmp11.map(v => '(' + v.industryNaceCode + ') ' + v.industryTitle)
                  }
                });
              } else {
                self.evaluations.push({
                  criterionTitle: criterionTitle,
                  criterionId: criterionId,
                  type: type,
                  bestPerforming: bestPerforming,
                  data: {
                    datasets: [
                      {
                        data: tmp11.map(v => v.evaluationAnalystAnswerNumeric),
                        backgroundColor: (bestPerforming) ? "rgb(106 225 171 / 0.53)" : "rgb(238 6 6 / 0.53)",
                        hoverBackgroundColor: (bestPerforming) ? "rgb(106 225 171 / 0.63)" : "rgb(238 6 6 / 0.63)",
                      }
                    ],
                    labels: tmp11.map(v => v.companyTradeTitle)
                  }
                });
              }
            }

            if (type === 'list') {
              let ttt = {
                criterionTitle: criterionTitle,
                criterionId: criterionId,
                type: type,
                bestPerforming: bestPerforming,
                data: []
              };
              if (isForIndustries) {
                for (let i=0; i<tmp11.length; i++) {
                  ttt.data.push({
                    '#': i+1,
                    industry: '(' + tmp11[i].industryNaceCode + ') ' + tmp11[i].industryTitle,
                    value: self.formatNumber(tmp11[i].evaluationAnalystAnswerNumeric)
                  });
                }
                self.industryEvaluations.push(ttt);
              } else {
                for (let i=0; i<tmp11.length; i++) {
                  ttt.data.push({
                    '#': i+1,
                    company: tmp11[i].companyTradeTitle,
                    value: self.formatNumber(tmp11[i].evaluationAnalystAnswerNumeric)
                  });
                }
                self.evaluations.push(ttt);
              }
            }
          } else {
            if (type === 'barchart') {
              if (isForIndustries) {
                self.industryEvaluations.push({
                  criterionTitle: criterionTitle,
                  criterionId: criterionId,
                  type: type,
                  bestPerforming: bestPerforming,
                  data: null
                });
              } else {
                self.evaluations.push({
                  criterionTitle: criterionTitle,
                  criterionId: criterionId,
                  type: type,
                  bestPerforming: bestPerforming,
                  data: null
                });
              }
            }

            if (type === 'list') {
              let ttt = {
                criterionTitle: criterionTitle,
                criterionId: criterionId,
                type: type,
                bestPerforming: bestPerforming,
                data: null
              };
              if (isForIndustries) {
                self.industryEvaluations.push(ttt);
              } else {
                self.evaluations.push(ttt);
              }
            }
          }
        })
        .catch((err) => {
          
        })
        .finally(() => {
          self.loading = false;
        });
      },
      formatNumber(number) {
        if (number > 1000000000000 || number < -1000000000000) {
          return (number/1000000000000).toFixed(2) + 'T'
        }

        if (number > 1000000000 || number < -1000000000) {
          return (number/1000000000).toFixed(2) + 'B'
        }

        if (number > 1000000 || number < -1000000) {
          return (number/1000000).toFixed(2) + 'M'
        }

        if (number > 1000 || number < -1000) {
          return (number/1000).toFixed(2) + 'K'
        }

        return parseFloat(number).toFixed(4).replace(/0+$/, "").replace(/\.$/, "");
      },
      fetchFrameworks() {
        let self = this;
        Api.send('GET', '/frameworks', {})
        .then((response) => {
          self.frameworks = response;
          self.fetchPillars();
        })
        .catch((err) => {
          
        });
      },
      fetchPillars() {
        let self = this;
        Api.send('GET', '/pillars', {})
        .then((response) => {
          self.pillars = response;
          self.fetchTopicsTree();
        })
        .catch((err) => {
          
        });
      },
      fetchTopicsTree() {
        let self = this;
        Api.send('GET', '/prism/topics/all/tree?with_criteria=1&exclude_non_quantitative=1', {})
        .then((response) => {
          self.topicsTree.environmental.childrenDtos = response.environmental;
          self.topicsTree.social.childrenDtos = response.social;
          self.topicsTree.governance.childrenDtos = response.governance;
          self.topicsTree.financial.childrenDtos = response.financial;
          self.topicsTree.general.childrenDtos = response.general;
          self.registerCriteriaFlat();
        })
        .catch((err) => {
          self.topicsTree.environmental.childrenDtos = [];
          self.topicsTree.social.childrenDtos = [];
          self.topicsTree.governance.childrenDtos = [];
          self.topicsTree.financial.childrenDtos = [];
          self.topicsTree.general.childrenDtos = [];
        });
      },
      registerCriteriaFlat() {
        for (let i in this.topicsTree.environmental.childrenDtos) {
          this.registerChildren(this.topicsTree.environmental.childrenDtos[i], 'environmental');
        }
        for (let i in this.topicsTree.social.childrenDtos) {
          this.registerChildren(this.topicsTree.social.childrenDtos[i], 'social');
        }
        for (let i in this.topicsTree.governance.childrenDtos) {
          this.registerChildren(this.topicsTree.governance.childrenDtos[i], 'governance');
        }
        for (let i in this.topicsTree.financial.childrenDtos) {
          this.registerChildren(this.topicsTree.financial.childrenDtos[i], 'financial');
        }
        for (let i in this.topicsTree.general.childrenDtos) {
          this.registerChildren(this.topicsTree.general.childrenDtos[i], 'general');
        }
        this.fetchCountries();
      },
      registerChildren(item, pillar) {
        this.criteriaFlat[pillar].push({
          code: 'topic-' + item.id,
          label: item.title,
          selectable: false
        });
        if (item.criteriaDtos.length > 0) {
          for (let i in item.criteriaDtos) {
            if (item.criteriaDtos[i].metaDto.expectsBooleanAnswer) {
              continue;
            }
            this.criteriaFlat[pillar].push({
              code: 'criterion-' + item.criteriaDtos[i].id,
              label: item.criteriaDtos[i].title,
              selectable: true
            });       
          }
        }
        if (item.childrenDtos.length > 0) {
          for (let i in item.childrenDtos) {
            this.registerChildren(item.childrenDtos[i], pillar)
          }
        }
      },
      addSelectedCriterion(criterionId, criterionTitle, type, isForIndustries, bestPerforming) {
        if (isForIndustries) {
          this.selectedIndustryCriteria.push({
            criterionId: criterionId,
            criterionTitle: criterionTitle,
            type: type,
            bestPerforming: bestPerforming
          });
        } else {
          this.selectedCriteria.push({
            criterionId: criterionId,
            criterionTitle: criterionTitle,
            type: type,
            bestPerforming: bestPerforming
          });
        }
        this.fetchAllCriterionEvaluations();
      },
      removeSelectedCriterion(criterionId, isForIndustries) {
        if (isForIndustries) {
          for (let j=0;j<this.selectedIndustryCriteria.length;j++) {
            if (this.selectedIndustryCriteria[j].criterionId == criterionId) {
              this.selectedIndustryCriteria.splice(j, 1);
            }
          }
          for (let i=0;i<this.industryEvaluations.length;i++) {
            if (this.industryEvaluations[i].criterionId == criterionId) {
              this.industryEvaluations.splice(i, 1);
            }
          }
        } else {
          for (let j=0;j<this.selectedCriteria.length;j++) {
            if (this.selectedCriteria[j].criterionId == criterionId) {
              this.selectedCriteria.splice(j, 1);
            }
          }
          for (let i=0;i<this.evaluations.length;i++) {
            if (this.evaluations[i].criterionId == criterionId) {
              this.evaluations.splice(i, 1);
            }
          }
        }

        localStorage.setItem('dashboard_industry_criteria', JSON.stringify(this.selectedIndustryCriteria));
        localStorage.setItem('dashboard_company_criteria', JSON.stringify(this.selectedCriteria));
      },
      fetchCountries() {
        let self = this;
        Api.send('GET', '/prism/countries', {})
        .then((response) => {
          response.map((countryDto) => {
            self.countriesFlat.push({
              code: countryDto.id,
              label: countryDto.title
            });
            self.countriesIndex[countryDto.id] = countryDto.title;
          });
        })
        .catch((err) => {
          
        });
      },
    },
    mounted() {
      for(let y=(new Date).getFullYear(); y > 2018; y--) {
        this.years.push(y);
      }
      this.i18n = this.$i18n;
      //this.initBigChart(0);
      this.selectedIndustryCriteria = JSON.parse(localStorage.getItem('dashboard_industry_criteria'));
      if (!this.selectedIndustryCriteria) {
        this.selectedIndustryCriteria = [];
      }
      this.selectedCriteria = JSON.parse(localStorage.getItem('dashboard_company_criteria'));
      if (!this.selectedCriteria) {
        this.selectedCriteria = [];
      }
      this.fetchFrameworks();
      this.fetchData();
    }
  };
</script>
<style>
#criteria_environmental_select.empty::before,
#criteria_social_select.empty::before,
#criteria_governance_select.empty::before,
#criteria_financial_select.empty::before,
#criteria_gri_select.empty::before {
  content: 'Select criterion';
  position: absolute;
  top: 5px;
  left: 10px;
}
.vs__dropdown-option--disabled {
  background: none !important;
  background-color: #e8e8e8 !important;
}
#country_filter {
  min-width: 140px !important;
}
#country_filter.empty::before {
  content: 'All Countries';
  position: absolute;
  top: 5px;
  left: 10px;
}
.icomoon-smile2 {
  color: #3fad7a;
} 
.icomoon-sad2 {
  color: #e9283e;
}
</style>
<style scoped>
/* L */
.card{border-radius: 1rem; margin-bottom: 20px;}
.card-body{padding:8px!important;}
.table{margin-bottom:0;}
.table-responsive{padding-bottom: 0;}
.btn{
  border-radius: 2rem;
  background: none;
  border: 2px solid black;
  color: black;
  padding: 8px 40px;
}

.btn:hover{background: black!important;color: #fff!important;}
.card-title{
  line-height: 1.3rem!important;
  font-weight: 400!important;
  margin-bottom: 1rem!important;
  width: 90%;
}

.card-body div {
  top:10px!important;
  right: 15px!important;
}

.col-1, .col-2, .col-3, .col-4, .col-5, 
.col-6, .col-7, .col-8, .col-9, .col-10, 
.col-11, .col-12, .col, .col-auto, .col-sm-1,
.col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, 
.col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, 
.col-sm-10, .col-sm-11, .col-sm-12, .col-sm, 
.col-sm-auto, .col-md-1, .col-md-2, .col-md-3, 
.col-md-4, .col-md-5, .col-md-6, .col-md-7, 
.col-md-8, .col-md-9, .col-md-10, .col-md-11, .col-md-12,
.col-md, .col-md-auto, .col-lg-1, .col-lg-2, .col-lg-3, 
.col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, 
.col-lg-10, .col-lg-11, .col-lg-12, .col-lg, .col-lg-auto, 
.col-xl-1, .col-xl-2, .col-xl-3, .col-xl-4, .col-xl-5, 
.col-xl-6, .col-xl-7, .col-xl-8, .col-xl-9, .col-xl-10, 
.col-xl-11, .col-xl-12, .col-xl, .col-xl-auto {padding-right: 7px!important; padding-left: 5px!important;}

tbody tr td{padding: 7px 7px!important;}

.text-muted-bg {
  padding: 10px;
  background: rgb(34 34 34 / 0.85);
  color: white!important;
  border-radius: 0.4rem;
}

.form-group button{
  width: 100%; 
}

.white-content .form-control {
  background: white;
  padding: 6px 18px;
  border-color: rgb(129 129 129 / 50%);
  border-radius: 0.3rem;

}
.form-control{
  height: 2.2rem;
}
</style>
